(ns pfo.dashboard.component
  (:require
    [reagent.core :as reagent :refer [atom]]
    [pfo.collection.model :as model]
    [pfo.state :as state]
    [pfo.util :as util :refer [set-page entity]]
    [pfo.task.model :as task-model]
    [pfo.task.component :as task]
    [pfo.widget.tabs :refer [tab tabs]]
    [pfo.api :as api :refer [process-error]]
    [pfo.message.component :as message]
    [pfo.auth.model :as auth-model :refer [perm has-perm]]
    [pfo.activity.component :as activity]
    [pfo.staging.component :as staging]
    [pfo.assignment.component :refer [assignment-list]]
    [promesa.core :as p]))


;; TODO: the dashboard is a mess:
;; The event list should
;; - show only events that the current user is invited to
;; - share a list component with task components (needed for "previous events")
;; The task list uses an ugly hack to reuse task-list component without
;; showing pagination

(defn dashboard [{:keys [focus-dropbox-sign-pending]}]
  (let [messages-tabs-active (atom :messages)
        signatures (atom nil)
        task-filter-show (atom false)
        compliance-filter-show (atom false)
        compliance-bulk-edit (atom nil)
        show-steps (atom false)
        chosen-tasks (atom #{})
        select-all (atom false)
        filter-collection-id (atom nil)
        signatures-filter-show (atom false)
        report-mode (atom false)
        alert-filter-show (atom false)]

    (add-watch report-mode :report-mode-filter-show
      (fn [_ _ oldv newv]
        (when (and (not= oldv newv) newv)
          (reset! compliance-filter-show true)
          (reset! task-filter-show true))))
    (when focus-dropbox-sign-pending
      (reset! state/task-tabs-active :signatures))

    (fn []
       [:div.u-shadow--bottom
        [tabs
         (tab
           [:span [:img.tab-header {:src "/static/img/icons/message.svg"}] [:span.name "Messages"]]
           :messages
           messages-tabs-active
           [message/message-list]
           nil)

         (tab
           [:span [:img.tab-header {:src "/static/img/icons/activity.svg"}] [:span.name "My activity"]]
           :activity
           messages-tabs-active
           [activity/user-activity]
           nil)

         (when (auth-model/can-access-document-review?)
           (tab
             [staging/documents-to-process-tab-label]
             :staging
             messages-tabs-active
             [staging/documents-to-process-preview]
             nil))

         (when (auth-model/show-my-uploads?)
           (tab
             [:span [:img.tab-header {:src "/static/img/icons/document.svg"}] [:span.name "My uploads"]]
             :my-uploads
             messages-tabs-active
             [staging/my-uploads-list]
             nil))]

        (when (or (has-perm :can_view_task) (has-perm :can_view_compliance) (has-perm :can_view_event))
          [tabs
          (when (or (has-perm :can_view_task) (has-perm :can_view_compliance))
            (tab
             [:span
              [:img.tab-header {:src "/static/img/icons/alert-off.svg"}] 
              [:span.name {:ref (fn [elem]          
                                  (when (and elem (= @state/task-tabs-active :alerts))
                                    (.scrollIntoView elem)))} "Alerts"]]
             :alerts
             state/task-tabs-active
             [pfo.task.component/task-list {:alert-active true
                                            :bulk-edit-atom (atom nil)} nil true "all" alert-filter-show]
             [pfo.task.component/alert-list-buttons alert-filter-show]))
           (perm :can_view_task
                 (tab
                   [:span [:img.tab-header.task {:src "/static/img/icons/task.svg"}] [:span.name "Tasks"]]
                   :tasks
                   state/task-tabs-active
                   [pfo.task.component/task-list {:bulk-edit-atom (atom nil)
                                                  :dashboard true
                                                  :filter-collection-id-atom filter-collection-id
                                                  :report-mode-atom report-mode} nil true "simple" task-filter-show]
                   [pfo.task.component/task-list-buttons {:filter-collection-id-atom filter-collection-id} nil task-filter-show report-mode]))
           (perm :can_view_compliance
                 (tab
                   [:span [:img.tab-header {:src "/static/img/icons/compliance.svg"}] [:span.name "Compliance"]]
                   :compliance
                   state/task-tabs-active
                   [pfo.task.component/task-list {:bulk-edit-atom compliance-bulk-edit
                                                  :show-steps-atom show-steps
                                                  :chosen-tasks-atom chosen-tasks
                                                  :select-all-atom select-all
                                                  :dashboard true
                                                  :filter-collection-id-atom filter-collection-id
                                                  :report-mode-atom report-mode} nil true "compliance" compliance-filter-show]
                   [pfo.task.component/compliance-list-buttons {:filter-collection-id-atom filter-collection-id
                                                                :show-steps-atom show-steps
                                                                :chosen-tasks-atom chosen-tasks
                                                                :select-all-atom select-all} nil compliance-filter-show compliance-bulk-edit report-mode]))
           (when (or (has-perm :can_view_task) (has-perm :can_view_compliance))
             (tab
               [:span [:img.tab-header {:src "/static/img/icons/signature.svg"}]
                [:span.name "Signatures"]]
               :signatures
               state/task-tabs-active
               [pfo.task.component/task-list {:signature true
                                              :dashboard true
                                              :signatures true
                                              :focus-dropbox-sign-pending focus-dropbox-sign-pending
                                              :bulk-edit-atom (atom nil)} nil true "all" signatures-filter-show]
               [pfo.task.component/signature-list-buttons signatures-filter-show]))
           (perm :can_view_event
                 (tab [:span [:img.tab-header {:src "/static/img/icons/event-blue.svg"}] [:span.name "Events"]]
                      :events
                      state/task-tabs-active
                      [pfo.task.component/event-list nil (api/get-auth-info :user-id) false true]
                      [:div
                       (when (has-perm :can_add_event)
                         [:button {:on-click #(util/set-location "#/event/add/")} "Add event"])]))
           (tab
             [:span [:img.tab-header {:src "/static/img/icons/all.svg"}] [:span.name "All"]]
             :all
             state/task-tabs-active
             [pfo.task.component/common-task-list nil nil true compliance-filter-show]
             [:div])])])))
